module.exports = __webpack_public_path__ + "static/img/banner02.5d07b23.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/banner02.png
// module id = 5aia
// module chunks = 26